import { MainProvider } from '@context/Main';
import MainView from './MainView';

const Main = () => {
  return (
    <MainProvider>
      <MainView />
    </MainProvider>
  );
};

export default Main;
